/*
 * OUTEQ — porovnání produktů (vzor mobileorigin.com).
 *
 * Klíč: 'outeqCompare' = pole product handlů, nejvýš MAX položek.
 * Stejný způsob práce jako u wishlistu (assets/outeq-wishlist.js), ať se to
 * chová a ladí stejně:
 *   - klik na cokoli s [data-compare] (+ handle z data-compare-handle nebo
 *     z nejbližšího [data-handle]) přepne produkt v porovnání,
 *   - [data-compare-count] = počet v hlavičce (při nule schovaný),
 *   - [data-compare-table] = tabulka na stránce /pages/porovnani.
 *
 * ODKUD SE BEROU DATA: všechno z `/products/<handle>?view=compare` — to je
 * odlehčená šablona
 * (`templates/product.compare.liquid`, `layout none`), která vrací název, cenu,
 * dostupnost a TÝŽ blok s parametry jako produktová stránka — 6 kB místo 600 kB.
 * Parametry se proto nemusí nikde duplikovat a tabulka se sama srovná s PDP,
 * jakmile se změní metapole.
 *
 * PAST: `/products/<handle>.js` tu použít NEJDE. Handly jsou přeložené, takže
 * pod /sk a /en vrátí český handle 404; HTML adresa se naopak přesměruje na
 * přeloženou variantu (i s `?view=compare`) a cenu naformátuje Liquid ve měně
 * trhu.
 *
 * Texty chodí z Liquidu přes data-* atributy sekce: tenhle soubor je statický
 * asset, Liquid se v něm nevyhodnotí, a natvrdo psaná čeština by na /sk a /en
 * zůstala česky.
 */
(function () {
  'use strict';

  if (window.__oqCompareInit) return;
  window.__oqCompareInit = true;

  var LS_KEY = 'outeqCompare';
  var MAX = 4;

  function read() {
    try {
      var l = JSON.parse(localStorage.getItem(LS_KEY)) || [];
      return Array.isArray(l) ? l.slice(0, MAX) : [];
    } catch (e) { return []; }
  }
  function write(l) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(l)); } catch (e) {}
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function emit() {
    try { document.dispatchEvent(new CustomEvent('compare:change', { detail: { count: read().length } })); } catch (e) {}
  }
  /** Vrací 'added' | 'removed' | 'full' — volající podle toho hlásí strop. */
  function toggle(h) {
    var l = read(), i = l.indexOf(h);
    if (i !== -1) { l.splice(i, 1); write(l); emit(); return 'removed'; }
    if (l.length >= MAX) return 'full';
    l.push(h); write(l); emit(); return 'added';
  }
  function remove(h) {
    var l = read(), i = l.indexOf(h);
    if (i !== -1) { l.splice(i, 1); write(l); emit(); }
  }

  window.OuteqCompare = { read: read, has: has, toggle: toggle, remove: remove, max: MAX };

  /* ---------- pomocné ---------- */
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  /** Kořen jazyka: na /sk a /en musí fetch i odkazy nést prefix. */
  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function handleOf(btn) {
    if (btn.getAttribute('data-compare-handle')) return btn.getAttribute('data-compare-handle');
    var c = btn.closest('[data-handle]');
    return c ? c.getAttribute('data-handle') : null;
  }

  /* ---------- stav tlačítek a počtu ---------- */
  function reflect(btn) {
    var h = handleOf(btn); if (!h) return;
    var a = has(h);
    if (btn.classList.contains('is-active') !== a) btn.classList.toggle('is-active', a);
    var ap = a ? 'true' : 'false';
    if (btn.getAttribute('aria-pressed') !== ap) btn.setAttribute('aria-pressed', ap);
  }
  function reflectAll() {
    document.querySelectorAll('[data-compare]').forEach(reflect);
    var n = String(read().length);
    document.querySelectorAll('[data-compare-count]').forEach(function (el) {
      if (el.textContent !== n) el.textContent = n;
      var hide = n === '0';
      if (el.hidden !== hide) el.hidden = hide;
    });
  }

  /** Hláška o stropu — jediné místo, kde se text bere z tlačítka. */
  function toast(msg) {
    if (!msg) return;
    var old = document.querySelector('.oq-compare-toast');
    if (old) old.remove();
    var t = document.createElement('div');
    t.className = 'oq-compare-toast';
    t.setAttribute('role', 'status');
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 3200);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-compare]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      var h = handleOf(btn);
      if (!h) return;
      var res = toggle(h);
      if (res === 'full') toast((btn.getAttribute('data-compare-full') || '').replace('{{ count }}', MAX).replace('{{count}}', MAX));
      return;
    }
    var rm = e.target.closest('[data-compare-remove]');
    if (rm) { e.preventDefault(); remove(rm.getAttribute('data-compare-remove')); }
  });

  /* ---------- tabulka na stránce porovnání ---------- */

  /** Řádky tabulky parametrů → [[popisek, hodnota]]. */
  function parseSpecs(doc) {
    var out = [];
    doc.querySelectorAll('.spec-table__row').forEach(function (row) {
      var l = row.querySelector('.spec-table__label');
      var v = row.querySelector('.spec-table__value');
      if (!l || !v) return;
      var label = l.textContent.trim();
      var value = v.textContent.replace(/\s+/g, ' ').trim();
      if (label && value) out.push([label, value]);
    });
    return out;
  }

  function load(handle) {
    var url = root() + 'products/' + encodeURIComponent(handle) + '?view=compare';
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var meta = doc.querySelector('[data-oq-compare-meta]');
        if (!meta) return null;
        var product;
        try { product = JSON.parse(meta.textContent); } catch (e) { return null; }
        product.handle = handle;
        return { product: product, specs: parseSpecs(doc) };
      })
      .catch(function () { return null; });
  }

  function renderTable() {
    var wrap = document.querySelector('[data-compare-table]');
    if (!wrap) return;
    var empty = document.querySelector('[data-compare-empty]');
    var loading = document.querySelector('[data-compare-loading]');
    var diffWrap = document.querySelector('[data-compare-diff-wrap]');
    var T = JSON.parse(wrap.getAttribute('data-compare-labels') || '{}');
    var list = read();

    if (!list.length) {
      wrap.innerHTML = '';
      if (loading) loading.hidden = true;
      if (diffWrap) diffWrap.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (loading) loading.hidden = false;

    Promise.all(list.map(load)).then(function (items) {
      items = items.filter(Boolean);
      if (loading) loading.hidden = true;
      if (!items.length) {
        wrap.innerHTML = '';
        if (diffWrap) diffWrap.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }
      if (diffWrap) diffWrap.hidden = items.length < 2;

      // Pořadí řádků drží první produkt; co mají jen ostatní, se přidá za něj.
      var labels = [];
      items.forEach(function (it) {
        it.specs.forEach(function (s) { if (labels.indexOf(s[0]) === -1) labels.push(s[0]); });
      });

      var head = '<tr><th class="oq-cmp__corner" scope="row"></th>' + items.map(function (it) {
        var p = it.product;
        return '<th class="oq-cmp__product" scope="col">' +
          '<button class="oq-cmp__remove" type="button" data-compare-remove="' + esc(p.handle) + '" aria-label="' + esc(T.remove || '') + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
          '</button>' +
          '<a class="oq-cmp__media" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(sized(p.image, 400)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
          '<a class="oq-cmp__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="oq-cmp__price">' + esc(p.price) + '</div>' +
          '<div class="oq-cmp__stock' + (p.available ? '' : ' oq-cmp__stock--out') + '">' + esc(p.available ? (T.in_stock || '') : (T.out_of_stock || '')) + '</div>' +
        '</th>';
      }).join('') + '</tr>';

      var rows = labels.map(function (label) {
        var values = items.map(function (it) {
          var hit = it.specs.filter(function (s) { return s[0] === label; })[0];
          return hit ? hit[1] : '—';
        });
        var same = values.every(function (v) { return v === values[0]; });
        return '<tr class="oq-cmp__row' + (same ? ' oq-cmp__row--same' : '') + '">' +
          '<th class="oq-cmp__label" scope="row">' + esc(label) + '</th>' +
          values.map(function (v) { return '<td class="oq-cmp__value">' + esc(v) + '</td>'; }).join('') +
        '</tr>';
      }).join('');

      // Šířka: sloupec s popisky + 220 px na produkt; užší okno tabulku posune.
      var minW = 200 + items.length * 220;
      wrap.innerHTML = '<table class="oq-cmp__table" style="min-width:' + minW + 'px"><thead>' + head + '</thead><tbody>' + rows + '</tbody></table>';
    });
  }

  /* Přepínač „jen rozdíly" — řádky se shodnou hodnotou se schovají CSS třídou,
     ať se tabulka nemusí překreslovat. */
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-compare-diff]');
    if (!cb) return;
    var wrap = document.querySelector('[data-compare-table]');
    if (wrap) wrap.classList.toggle('is-diff-only', cb.checked);
  });

  /* ---------- init ---------- */
  function init() { reflectAll(); renderTable(); }

  document.addEventListener('compare:change', function () { reflectAll(); renderTable(); });
  document.addEventListener('shopify:section:load', function () { reflectAll(); renderTable(); });

  // Karty se donačítají filtry i stránkováním → po změně DOMu obarvit znovu.
  if (window.MutationObserver) {
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(reflectAll, 200); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
